function initScheme() {
	require.ensure(['./scheme.js'], function (require) {
		require('./scheme.js');
	});
}

if ($('#business-model1').length) {
	initScheme();
}



/** WEBPACK FOOTER **
 ** ./frontend/components/business-model/business-model.js
 **/